import { gql } from 'apollo-angular'

export const GET_EDITORIAL_BOARD = gql`
  query GetEditorialBoard($edition: Int!) {
    Edition(id: $edition, select: true) {
      id
      colophon {
        type
        title
        authors {
          id
          pre_title
          first_name
          middle_name
          last_name
          post_title
          initials
          pdf_author_name
        }
      }
    }
  }
`
